import { render, staticRenderFns } from "./ModalGoalUser.vue?vue&type=template&id=19bd0412&scoped=true&"
import script from "./ModalGoalUser.vue?vue&type=script&lang=js&"
export * from "./ModalGoalUser.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=19bd0412&scoped=true&lang=css&"
import style1 from "./ModalGoalUser.vue?vue&type=style&index=1&id=19bd0412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd0412",
  null
  
)

export default component.exports